import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Ahmed Hassan",
      country: "UAE",
      rating: 5,
      text: "Excellent service from start to finish. The vehicle arrived in perfect condition and exactly as described. Highly recommended!",
      vehicle: "2020 Toyota Land Cruiser"
    },
    {
      name: "Michael Thompson",
      country: "Kenya",
      rating: 5,
      text: "Very professional team. They guided me through the entire import process and the vehicle quality exceeded my expectations.",
      vehicle: "2018 Nissan X-Trail"
    },
    {
      name: "Carlos Rodriguez",
      country: "Chile",
      rating: 5,
      text: "Best prices for Japanese vehicles. Great communication and fast shipping. Will definitely buy again.",
      vehicle: "2019 Toyota Hilux"
    },
    {
      name: "Priya Sharma",
      country: "India",
      rating: 5,
      text: "Trustworthy company with transparent pricing. The car is in excellent condition and the paperwork was handled smoothly.",
      vehicle: "2017 Honda Fit"
    }
  ];

  return (
    <div className="relative py-20 bg-gray-900 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.pexels.com/photos/3604258/pexels-photo-3604258.jpeg?w=1920&q=85"
          alt="Background"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/95 via-gray-800/90 to-gray-900/95"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">What Our Customers Say</h2>
          <p className="text-lg text-gray-300">Trusted by customers worldwide</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="hover:shadow-xl transition-all duration-300 bg-white/10 backdrop-blur-sm border-white/20">
              <CardContent className="p-6">
                <div className="mb-4">
                  <Quote className="h-8 w-8 text-red-600 opacity-50" />
                </div>
                
                {/* Rating */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                {/* Testimonial Text */}
                <p className="text-gray-200 text-sm mb-4 italic">
                  "{testimonial.text}"
                </p>
                
                {/* Customer Info */}
                <div className="border-t border-white/20 pt-4">
                  <p className="font-semibold text-white">{testimonial.name}</p>
                  <p className="text-sm text-gray-300">{testimonial.country}</p>
                  <p className="text-xs text-red-400 mt-2">{testimonial.vehicle}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-red-500 mb-2">10+</div>
            <div className="text-sm text-gray-300">Vehicles In Stock</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">7,000+</div>
            <div className="text-sm text-gray-600">Happy Customers</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">50+</div>
            <div className="text-sm text-gray-600">Countries Served</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">100%</div>
            <div className="text-sm text-gray-600">Verified Quality</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;